import { SharedPushApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useSharedPushApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(() => new SharedPushApi(configuration), [configuration]);
};
